import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'c-piechart',
    templateUrl: './piechart.component.html',
    styleUrl: './piechart.component.css',
    standalone: false
})
export class PiechartComponent {
  /* y -> porcentaje
    nombre -> nombre división
    color -> color división
  */
  @Input() data: {
    y: number;
    nombre: string;
    color: string;
  }[] = [];

  // Color de fondo para división
  @Input() color: string = '';

  chartOptions: any;

  /**
   * @description Actualiza el gráfico según información recibida
   */
  ngOnChanges(): void {
    const total = this.data.reduce((sum, item) => sum + item.y, 0);

    this.chartOptions = {
      animationEnabled: true,
      legend: {
        horizontalAlign: 'center',
        verticalAlign: 'top',
        cursor: 'pointer',
      },
      data: [
        {
          type: 'pie',
          startAngle: -90,
          // Información mostrada señalando la división del gráfico
          indexLabel: '{nombre}: {y}',
          // Información mostrada al pasar cursor sobre alguna división
          toolTipContent: '{toolTipContent}',
          // Formato mostrado para porcentaje
          showInLegend: true,
          yValueFormatString: "#,###.##'%'",
          dataPoints: this.data.map((item) => {
            const porcentaje = total > 0 ? (item.y / total) * 100 : 0;
            return {
              y: porcentaje, // para que el gráfico funcione bien
              nombre: item.nombre,
              legendText: `${item.nombre}: ${item.y}`, // mostrar valor real
              toolTipContent: `${item.nombre}: ${item.y}`, // también mostrar valor real
              color: this.getColorClass(item.color),
            };
          }),
        },
      ],
    };
  }

  /**
   * @description Definimos los colores según caso esperado -> adaptación
   * para uso correcto de canvaJS
   */
  getColorClass(colorKey: string): string {
    switch (colorKey) {
      case '3':
        return '#DC2626'; // rojo
      case '1':
        return '#22C55E'; // verde
      case '2':
        return '#FACC15'; // amarillo
      case '0':
        return '#FDBA74'; // naranja
      default:
        return '#D1D5DB'; // gris
    }
  }
}
